import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const CurrencyService = {
  getList: async () => {
    const response = await apiService.get(`/${slug}/currency/getlist`);
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(
      `/${slug}/currency/getdetail?id=${id}`
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(
      `/${slug}/currency/delete?id=${id}`
    );
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.patch(
        `/${slug}/currency/update?id=${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating currency:", error);
      throw error;
    }
  },
  create: async (values) => {
    try {
      const response = await apiService.post(
        `/${slug}/currency/create`,
        values
      );
      return response.data;
    } catch (error) {
      console.error("Error creating currency:", error);
      throw error;
    }
  },
};

export default CurrencyService;
